import React from 'react';
import { FormGroup, ModalHeader, Button, ModalBody, NavLink, Popover, PopoverBody } from 'reactstrap';
import { modalWrapper } from 'components/FDModal';
import { filterSCByBankName } from 'components/Common';
import { isEmptyOrUndefined } from 'lib/fp-utility';
import TYPE_OF_CARD from 'assets/images/bank-card.png';
import SavedCardForm from 'components/Common/saved-card-form';
import  CardForm from 'components/Common/card-form'

class EMICardForm extends React.Component {

    state = { canShowNewCard: false }
    
    showNewCard = this.showNewCard.bind(this);
	openTermsUrl = this.openTermsUrl.bind(this)
	hideTermsPop = this.hideTermsPop.bind(this)
	toggleTermsPop = this.toggleTermsPop.bind(this)

    componentDidMount(){
        const { savedCards, selectedEmiBank } = this.props
        const filterSC = filterSCByBankName(savedCards, selectedEmiBank.bankname)
        if(isEmptyOrUndefined(filterSC)){
            this.setState({canShowNewCard: true})
        }
    }

    showNewCard(){
        this.hideTermsPop()
        this.setState({canShowNewCard: true})
    }

	toggleTermsPop(){
		this.setState({ terms: !this.state.terms });
    } 
    
    hideTermsPop(){
		this.setState({ terms: false });
    } 
	
	openTermsUrl(){
		this.hideTermsPop()
		window.open(this.props.termsAndConditionsUrl, '_blank')
	}

    render() {
        const { t ,emiCardType} = this.props;
        return (
            <>
                <ModalHeader toggle={this.props.toggleEMICardModal}>EMI</ModalHeader>
                <ModalBody>
                    <h6>{this.props.selectedEmiBank.bankname} {t('Credit Card')} - {this.props.selectedEMIOption.emitenure} EMIs @ {t(this.props.emiCurrency)}{this.props.selectedEMIOption.emipermonth}/{t('month')}</h6>
                    {
                        !this.state.canShowNewCard && this.props.savedCards &&
                        <FormGroup>    
                            <figure className="text-center">
                                <img src={TYPE_OF_CARD} alt="card" title="" />
                            </figure>
                            <h5>{t('Saved Cards')}</h5>
                            <SavedCardForm t={t} from='EMISC' btnName={t('Proceed')}
                                showNewCard={this.showNewCard}
                                bankname={this.props.selectedEmiBank.bankname}
                                bankcode={this.props.selectedEmiBank.bankcode}     
                                emiTenure={this.props.selectedEMIOption.emitenure}
                            />
                        </FormGroup>
                    }
                    { 
                        this.state.canShowNewCard &&
                        <div className="card-details-panel">
                            <CardForm 
                                from='EMIC' t={t} btnName={t('Proceed')}
                                canDisplaySaveCard={true}
                                bankname={this.props.selectedEmiBank.bankname}
                                bankcode={this.props.selectedEmiBank.bankcode}
                                emitenure={this.props.selectedEMIOption.emitenure}
								selectedEMIOption={this.props.selectedEMIOption}
                                backLink="noNeed"
                                emiCardType = {emiCardType}
                            />
                        </div>
                    }
                    <Button outline onClick={this.props.toggleEMICardModal} color="secondary col-12">{t('choose_plan')}</Button>
                    {
                        this.props.termsAndConditionsUrl &&
                        <>
                            <NavLink className="textBlue-14 text-left p-0 notLine" > 
                                <span onClick={this.toggleTermsPop} className="icon-info" id="emiInfoPopup"></span> 
                                {t('terms_conditions')}
                            </NavLink>
                            <Popover className="popover-emi" placement="top" isOpen={this.state.terms}  target={'emiInfoPopup'}>
                                <PopoverBody>
                                    <p className="textGray-12 mb-2"><strong>{t('Note')}:</strong>{t('emi_order_note')}</p>
                                    <p className="textGray-12">*{t('installment_amount')} <NavLink onClick={this.openTermsUrl}>{t('click_for_banks')}</NavLink></p>
                                </PopoverBody>
                            </Popover>
                        </>
                    }
                </ModalBody>
            </>
        )
    }
}

export default modalWrapper(true, "EMICardModal")(EMICardForm)